import { FC } from 'react';
import classNames from 'classnames';
import { NavSection } from '../../../ducks/features/navPanelSlice';

import './NavRailIcon.scss';

interface IProps {
  icon: string;
  label: string;
  active?: boolean;
  outlined?: boolean;
  section?: NavSection;
  bordered?: boolean;
  disabled?: boolean;
  onClick: () => void;
  ariaExpanded?: boolean;
  ariaControls?: string;
}

const NavRailIcon: FC<IProps> = ({
  icon,
  label,
  active,
  outlined,
  bordered,
  disabled,
  onClick,
  ariaExpanded,
  ariaControls,
}) => {
  const iconClass = outlined ? 'material-icons-outlined' : 'material-icons';

  return (
    <button
      className={classNames('NavRailIcon', {
        'NavRailIcon--bordered': bordered,
      })}
      disabled={disabled}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-current={active ? 'page' : undefined}
      type="button"
    >
      <div className={classNames('NavRailIcon-inner', { 'NavRailIcon-inner--active': active })}>
        <span className={iconClass}>{icon}</span>
        <span className="NavRailIcon-label">{label}</span>
      </div>
    </button>
  );
};

export default NavRailIcon;
